import { useState } from 'react';
import { 
  Modal, 
  Box, 
  TextField, 
  Button, 
  Typography, 
  Divider,
  useMediaQuery,
  useTheme,
  InputAdornment
} from '@mui/material';
import PaymentIcon from '@mui/icons-material/Payment';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  width: '90%',
  maxWidth: 500,
  p: 3,
};

export default function AddPaymentModal({ 
  open, 
  onClose, 
  order, 
  clientId,
  onAddPayment 
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [amount, setAmount] = useState('');
  const [date, setDate] = useState(new Date().toISOString().slice(0, 16));
  const [comment, setComment] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!amount || isNaN(amount) || amount <= 0) {
      alert('Тўгри суммани киритинг!');
      return;
    }
    
    setIsSubmitting(true);
    try {
      await onAddPayment(clientId, order.id, {
        amount: parseFloat(amount),
        date,
        comment
      });
      onClose(true);
    } catch (error) {
      console.error("Ошибка при добавлении платежа:", error);
      alert(error.message || "Тўлов қўшишда ҳатолик болди!");
    } finally {
      setIsSubmitting(false);
    }
  };

  const formatMoney = (value) => {
    if (!value) return '';
    const num = value.toString().replace(/\D/g, '');
    return num.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  };

  const formatCurrency = (amount) => {
    return amount ? `${formatMoney(amount)} Сумм` : '0 Сумм';
  };

  return (
    <Modal open={open} onClose={() => !isSubmitting && onClose(false)}>
      <Box sx={style}>
        <Typography variant="h6" gutterBottom>
          Тўлов қўшиш
        </Typography>
        
        <Typography variant="body1" gutterBottom>
          Буйуртма суммаси: {formatCurrency(order.totalAmount)}
        </Typography>

        <Typography variant="body1" gutterBottom sx={{ fontWeight: 'bold', color: order.totalAmount - order.paymentInfo.paidAmount > 0 ? 'red' : 'green' }}>
          Тўланмаган суммаси: {formatCurrency(Math.max(0, order.totalAmount - order.paymentInfo.paidAmount))}
        </Typography>
        
        <Divider sx={{ my: 2 }} />
        
        <TextField
          label="Тўлов суммаси"
          type="text"
          fullWidth
          margin="normal"
          size="small"
          value={formatMoney(amount)}
          onChange={(e) => {
            const value = e.target.value.replace(/\s/g, '');
            setAmount(value === '' ? '' : parseFloat(value) || 0);
          }}
          required
          InputProps={{
            endAdornment: <InputAdornment position="end">Сумм</InputAdornment>,
          }}
          disabled={isSubmitting}
        />
        
        <TextField
          label="Тўлов санаси"
          type="datetime-local"
          fullWidth
          margin="normal"
          size="small"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          disabled={isSubmitting}
        />
        
        <TextField
          label="Тўлов изоҳи"
          fullWidth
          margin="normal"
          size="small"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          disabled={isSubmitting}
        />
        
        <Divider sx={{ my: 2 }} />
        
        <Box sx={{ 
          display: 'flex', 
          flexDirection: isMobile ? 'column' : 'row',
          justifyContent: 'flex-end',
          mt: 2,
          gap: 1
        }}>
          <Button 
            onClick={handleSubmit} 
            variant="contained"
            disabled={isSubmitting}
            startIcon={<PaymentIcon />}
            fullWidth={isMobile}
          >
            {isSubmitting ? 'Сақланияпти...' : 'Сақлаш'}
          </Button>
          <Button 
            onClick={() => onClose(false)} 
            disabled={isSubmitting}
            fullWidth={isMobile}
          >
            Бекор қилиш
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}